import CircularProgress from "@mui/material/CircularProgress";
import "./styles.css";

const circularLoader = ({position, size}) => {
  return (
    <div style={{width : '75%', display: 'flex', justifyContent:'center'}}>
       <div className={`custom-position ${position}`}>
        <CircularProgress size={size} color="secondary" />
      </div>
    </div>
  )
}

export default circularLoader;
